import * as XLSX from 'xlsx'
import { KEY, RES_PER_PAGE } from './config'
// state

export const state = {
	addresses: [],
	filteredAddreses: [],
	errors: [],
	pagination: {
		page: 1,

		resultPerPage: RES_PER_PAGE,
	},
}

export const resetState = function () {
	state.addresses = []
	state.filteredAddreses = []
	state.errors = []
	state.pagination.page = 1
}

// IMPORT FILE FROM XLS, CONVERT FILE DATA INTO JSON

const pushErrorToArr = function (err) {
	state.errors.push(err.message)
}

// Mapbox limituje Directions API do 300 zapytań/min, Geocoding do 600/min.
// Przetwarzamy adresy w paczkach z odstępem, żeby nie przekroczyć limitu przy dużych plikach.
const RATE_LIMIT_BATCH_SIZE = 20
const RATE_LIMIT_DELAY_MS = 5000

const processInBatches = async function (items, handler) {
	for (let i = 0; i < items.length; i += RATE_LIMIT_BATCH_SIZE) {
		const batch = items.slice(i, i + RATE_LIMIT_BATCH_SIZE)
		await Promise.all(batch.map(handler))

		if (i + RATE_LIMIT_BATCH_SIZE < items.length) {
			await new Promise(resolve => setTimeout(resolve, RATE_LIMIT_DELAY_MS))
		}
	}
}

export const ImportDataFromXlsFile = async function () {
	try {
		// pobieramy input
		const inputFile = document.getElementById('input')
		// sprawdzamy czy input posiada wybrany plik
		if (!inputFile.files.length) {
			throw new Error('nie wybrano pliku')
		}
		// wybieramy plik
		const selectedFile = inputFile.files[0]
		// sprawdzamy czy plik ma dane
		if (selectedFile.size === 0) {
			throw new Error('Wybrany plik jest pusty')
		}
		// sprawdzamy roszczerzenie pliku
		const fileExtension = selectedFile.name.split('.').at(-1)

		if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
			throw new Error('Nieprawidłowy format pliku')
		}

		const arrayBuffer = await selectedFile.arrayBuffer()

		const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: 'array' })

		if (workbook.SheetNames.length === 0) {
			throw new Error('Plik nie zawiera żadnych arkuszy')
		}
		// wybieramy arkusz
		const sheet = workbook.Sheets[workbook.SheetNames[0]]

		const data = XLSX.utils.sheet_to_json(sheet)

		if (data.length === 0) {
			throw new Error('Brak danych w arkuszu')
		}
		// aktualizujemy stan o dane z pliku
		state.addresses = [...data]
	} catch (err) {
		pushErrorToArr(err)
		return
	}
}

// GEOCODING

const getCoords = async function (street, postcode, city) {
	try {
		const address = [street, postcode, city].filter(Boolean).join(', ')
		const URL = `https://api.mapbox.com/geocoding/v5/mapbox.places/`
		const response = await fetch(`${URL}${encodeURIComponent(address)}.json?access_token=${KEY}`)

		if (!response.ok) {
			throw new Error(`bład w zapytaniu : ${response.status}`)
		}

		const data = await response.json()

		if (data.features.length === 0) {
			throw new Error(`dla adresu ${address} nie udało się ustalić koordynatów`)
		}

		return data.features[0].center
	} catch (err) {
		pushErrorToArr(err)
		return null
	}
}

// UPDATE ADDRESES WITH COORDS:

export const updateAddressesWithLocationData = async function () {
	try {
		await processInBatches(state.addresses, async el => {
			el.loadingCoords = (await getCoords(el.loadingStreet, el.loadingPostcode, el.loadingCity)) || [null, null]
			el.unloadingCoords = (await getCoords(el.unloadingStreet, el.unloadingPostcode, el.unloadingCity)) || [
				null,
				null,
			]
		})
	} catch (err) {
		pushErrorToArr(err)
		return null
	}
}

const calcDistance = async function (loadingCoords, unloadingCoords) {
	try {
		if (loadingCoords.some(c => c === null) || unloadingCoords.some(c => c === null))
			throw new Error(`Nie wszystkie dystanse zostały obliczone`)

		const [long, lat] = loadingCoords
		const [long2, lat2] = unloadingCoords
		const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${long},${lat};${long2},${lat2}?access_token=${KEY}`

		const response = await fetch(url)
		const data = await response.json()

		const distance = Math.floor(data.routes[0].distance / 1000)
		return distance
	} catch (err) {
		pushErrorToArr(err)
		return null
	}
}

export const updateAddressesWithDistance = async function () {
	try {
		const isRoundTrip = document.querySelector('.route-type-select').value === 'round-trip'

		await processInBatches(state.addresses, async el => {
			const distance = await calcDistance(el.loadingCoords, el.unloadingCoords)
			el.distance = distance === null ? null : isRoundTrip ? distance * 2 : distance
		})
	} catch (err) {
		pushErrorToArr(err)
		return null
	}
}

export const getSlicedResults = function (page = state.pagination.page) {
	// przypisuje wszystkie adresy do state.imported. results
	state.pagination.page = page
	const dataSource = state.filteredAddreses.length ? state.filteredAddreses : state.addresses
	const start = (page - 1) * state.pagination.resultPerPage //0
	const end = page * state.pagination.resultPerPage // 20
	return dataSource.slice(start, end) // wycinam tylko potrzebny kawałek z nowej tablicy
}
